import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "react-query";
import ReactGA from "react-ga4";

import App from "./App";
import { theme } from "./styles/theme";

const queryClient = new QueryClient();
ReactGA.initialize("G-5WP3RBMGXX");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </ChakraProvider>
);
